import type { RouteRecordRaw } from "vue-router";
import { auth } from "@/mixins/firebase";
import { useAuthStore } from "@/stores/auth";

export const rootRoutes: RouteRecordRaw[] = [
  {
    path: "/",
    name: "home",
    //@ts-ignore TODO: convert view in to typescript
    component: () => import("../../views/404.vue"),
    meta: {
      hideSidebar: true,
    },
    beforeEnter: (_to, from) => {
      const redirectPath = from.query?.redirect;
      if (redirectPath && typeof redirectPath === "string") {
        // A string location, so the redirect keeps its query (e.g. a shared tab and interval)
        return redirectPath;
      }

      const authStore = useAuthStore();

      if (!authStore.is.loggedIn()) {
        return { path: "/login" };
      }

      return { path: "/mimbox" };
    },
  },
  {
    path: "/login",
    name: "login",
    // @ts-ignore TODO: convert view to typescript
    component: () => import("../../views/LoginView.vue"),
    meta: {
      hideSidebar: true,
    },
    beforeEnter: (to, _from) => {
      const authStore = useAuthStore();
      if (!authStore.is.loggedIn()) {
        return true;
      }

      const redirectPath = to.query?.redirect;
      if (redirectPath && typeof redirectPath === "string") {
        // A string location, so the redirect keeps its query (e.g. a shared tab and interval)
        return redirectPath;
      }

      return { path: "/mimbox" };
    },
  },
  {
    path: "/coming-soon",
    name: "coming-soon",
    // @ts-ignore TODO: convert view to typescript
    component: () => import("../../views/ComingSoonView.vue"),
    beforeEnter: () => {
      auth.signOut();
    },
  },
  {
    path: "/connection-error",
    name: "connection-error",
    component: () => import("../../views/ConnectionErrorView.vue"),
    meta: {
      hideSidebar: true,
    },
  },
  {
    path: "/:pathMatch(.*)*",
    name: "404",
    // @ts-ignore TODO: convert view to typescript
    component: () => import("../../views/404.vue"),
  },
];
